import ContactForm from "components/forms/ContactForm"
import GoogleMap from "components/GoogleMap"
import Hero from "components/Hero"
import Layout, { Container, Section } from "components/Layout"
import SEO from "components/Seo"

import type { NextPage } from "next"

const ContactUs: NextPage = () => {
  return (
    <>
      <SEO
        titleTag="Contact Us | Speak To The Team | 3H CCTV &amp; Alarms"
        metaDescription="Speak to a security expert at 3H CCTV &amp; Alarms Ripley. We work across Derbyshire, Nottinghamshire &amp; South Yorkshire."
        pageTitle="Contact us"
      />
      <Layout>
        <Hero heading="Contact us" />

        <Section>
          <Container className="grid smmax:grid-cols-1 mdmin:grid-cols-2 smmax:gap-4 mdmin:gap-6">
            <div>
              <p>
                Whether you&rsquo;re looking for a quote for your home,
                business, or just looking for some friendly advice, don&rsquo;t
                hesitate to get in touch with us and speak to one of our
                friendly advisors
              </p>
              <ContactForm />
            </div>
            <GoogleMap />
          </Container>
        </Section>
      </Layout>
    </>
  )
}

export default ContactUs
